import { checkout as checkoutEnUS } from '../en-us/checkout';

export const checkout = {
  ...checkoutEnUS,
  shippingFields: {
    ...checkoutEnUS.shippingFields,
    isCreateAccount: `<p>Stay committed! You'll receive tips, inspiration, and community news via email, and we'll occasionally seek your feedback. You can opt out anytime. See our 
<a href="https://drinkag1.com/en-uk/privacy" target="_blank" aria-label="privacy policy (Opens in a new tab)" rel="noopener">privacy policy</a>
 for details.</p>`
  }
};
